<template>
  <div>
    <!-- <div
      id="ProfileHeader"
      class="ProfileHeader">
      <div class="Card">
        <div class="ProfileHeader-userCover">
          <div class="UserCoverEditor">
            <div>
              <div class="UserCover UserCover--colorBlock"></div>
            </div>
          </div>
        </div>
        <div class="ProfileHeader-wrapper">
          <div class="ProfileHeader-main">
            <div
              class="UserAvatarEditor ProfileHeader-avatar"
              style="top: -74px"
            >
              <div class="UserAvatar">
                <img
                  class="Avatar Avatar--large UserAvatar-inner"
                  width="160"
                  height="160"
                  :src="user.FaceImg?'https://puliedu.1plus.store/'+user.FaceImg: 'https://pic4.zhimg.com/da8e974dc_xl.jpg'"
                  srcset="https://pic4.zhimg.com/da8e974dc_xll.jpg 2x"/>
              </div>
            </div>
            <div class="ProfileHeader-content">
              <div class="ProfileHeader-contentHead">
                <h1 class="ProfileHeader-title">
                  <span class="ProfileHeader-name">{{user.RealName}}</span>
                  <span class="ztext ProfileHeader-headline">程序员</span>
                </h1>
              </div>
              <div class="ProfileHeader-contentFooter">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="teacherInformation">
      <div class="teacher_contop">
        <img
          class="UserCover-image"
          src="../../assets/images/bbsbackground.jpg"
          alt="用户封面"
          width="100%"
          height="100%"
        />
      </div>
      <div class="width_1200">
        <div class="teacherpic_box">
          <img
            v-if="user.HeadImg"
            v-lazy="GLOBAL.hostUrl + user.HeadImg"
            alt=""
          />
          <img v-else src="@/assets/images/avatar_default.png" alt="" />
          <div class="teacherinfo">
            <p>{{ user.RealName }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="Topstory-container">
      <div class="Topstory-mainColumn">
        <div v-for="(item, index) in feedList" :key="index">
          <feed-item
            :feedList="item"
            :isDelete="category == 2 ? true : false"
          ></feed-item>
        </div>
        <div v-if="feedList.length <= 0">
          <no-data></no-data>
        </div>
        <div class="Loading" v-show="isLoad">拼命加载中</div>
        <div class="Loading" v-show="isEnd">我是有底线的</div>
      </div>
      <div class="GlobalSideBar">
        <global-side-bar></global-side-bar>
      </div>
      <!-- 查看 -->
      <AskModal
        v-if="showModal"
        :dialogVisible="showModal"
        :row="sectionList"
        @close="showModal = false"
      ></AskModal>

      <!-- 登录遮罩层 -->
      <modal :showModal="showLoginModal" @cancel="showLoginModal = false">
        <template v-slot:dialog>
          <div class="Login-wrap">
            <el-tabs>
              <el-tab-pane label="密码登陆" name="login">
                <div class="Sign-wrap">
                  <input
                    class="SignInput"
                    type="text"
                    placeholder="用户名"
                    v-model="loginUser"
                  />
                </div>
                <div class="Sign-wrap">
                  <input
                    class="SignInput"
                    type="password"
                    placeholder="密码"
                    v-model="loginPass"
                  />
                </div>
                <button class="SubmitButton" @click="login">登陆</button>
              </el-tab-pane>
            </el-tabs>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import { queryAllTopicList, querySectionList } from "@/api/bbs";
import FeedItem from "@/components/bbs/FeedItem.vue";
import GlobalSideBar from "@/components/bbs/GlobalSideBar.vue";
import Modal from "@/components/bbs/Modal.vue";
import AskModal from "@/components/bbs/AskModal.vue";
import noData from "@/components/noData";
// import { mapGetters } from "vuex";

let Load;
export default {
  name: "index",
  components: {
    FeedItem,
    GlobalSideBar,
    Modal,
    AskModal,
    noData
  },
  computed: {
    //监听词条
    // ...mapGetters(["isAdd", "searchList"])
  },
  provide () {
    return {
      finishDelete: this.finishDelete
    }
  },
  watch: {
    isAdd: function (newValue) {
      // this.getContent();
      this.postQueryAllTopicList();
    },
    searchList: function (newValue) {
      this.feedList = newValue;
      console.log("更新列表");
    },
    category (val, oldVal) {//普通的watch监听
      console.log("category: " + val, oldVal);
    },
    $route: {
      handler () {
        this.category = this.$route.query.category;
        this.feedList = [];
        this.recPage = 1;
        this.postQueryAllTopicList();
        //深度监听，同时也可监听到param参数变化
      },
      deep: true,
    }
  },
  data () {
    return {
      feedList: [],
      activeName: "",
      followList: [],
      isLoad: false,
      recPage: 1, //推荐页面page
      // attPage: 1, //关注页面page
      pageSize: 10,
      isEnd: false,
      user: {},
      sectionList: [],
      sectionId: 1,
      showLoginModal: false,
      showModal: false,
      disabled: true,
      askDetail: "", //提问细节
      askTip: "",
      askTitle: "", //提问问题
      loginUser: "", //登录用户
      loginPass: "", //注册密码
      category: 0
    };
  },
  mounted () {
    // this.getContent();
    if (localStorage.getItem("userInfo") != null) {
      this.user = JSON.parse(localStorage.getItem("userInfo"));
    } else {
      this.user.Id = 0;
    }
    console.log(this.user, '')
    this.category = this.$route.query.category;
    //this.activeName = this.category==1?"myCollection":"myTopic";
    // this.postQuerySectionList();
    this.postQueryAllTopicList();
    window.addEventListener('scroll', this.listenScroll);
  },
  methods: {
    showLoginModalFn () {
      this.showLoginModal = true;
    },
    finishDelete (id) {
      this.feedList.some((item, i) => {
        if (item.Id == id) {
          this.feedList.splice(i, 1)
          //在数组的some方法中，如果return true，就会立即终止这个数组的后续循环
          return true
        }
      })
    },
    showAskModal () {
      this.showModal = true;
      console.log(this.showModal);
    },
    //登录
    login () {
      let params = {
        username: this.loginUser,
        password: this.loginPass,
        rememberme: this.checked,
      };
      this.axios.post("/login", params).then((res) => {
        if (res.status == 200) {
          this.$message({
            message: "登录成功",
            type: "success",
          });
          localStorage.setItem("user", JSON.stringify(res.data.user));
          this.user = res.data.user;
          this.showLoginModal = false;
          this.isLogin = true;
        }
      });
    },
    // 列表数据
    async postQueryAllTopicList () {
      let parm = {};
      parm.pageIndex = this.recPage;
      parm.pageSize = this.pageSize;
      parm.IsAll = false;
      parm.IsMyCollection = false;
      parm.UserId = this.user.Id;
      // parm.sectionId = this.sectionId;
      if (this.category == 1) {
        parm.IsMyCollection = true;
      }
      const res = await queryAllTopicList(parm);
      this.feedList = this.feedList.concat(res.data);
      this.$store.dispatch("setIsAdd", false);
      this.isLoad = false;
      if (res.data.length == 0) {
        this.isEnd = true;
      }
    },
    //滚动
    listenScroll () {
      let that = this;
      let ele = document.documentElement;
      let scr = ele.scrollTop; // 向上滚动的那一部分高度
      let clientHeight = ele.clientHeight; // 屏幕高度也就是当前设备静态下你所看到的视觉高度
      let scrHeight = ele.scrollHeight; // 整个网页的实际高度，兼容Pc端
      if (scr + clientHeight + 5 >= scrHeight) {
        // console.log(that.isEnd);
        // if (that.isLoad == false||this.isEnd == false) {
        if (that.isEnd == false) {
          // that.isLoad = true;
          that.recPage++;
          that.postQueryAllTopicList();
        }
      }
    },
    changeItem: function (tab, event) {
      this.category = tab.$attrs.category;
      this.feedList = [];
      this.recPage = 1;
      this.postQueryAllTopicList();
    },
    //发表问题
    publishQues () {
      let params = {
        title: this.askTitle,
        content: this.askDetail,
      };
      this.axios.post("/question/add", params).then((res) => {
        if (res.status == 200) {
          this.$message({
            message: "提问成功",
            type: "success",
          });
          this.showModal = false;
          this.askTitle = "";
          this.askDetail = "";
          this.$store.dispatch("setIsAdd", true);
        }
      });
    },
    //监听标题文字数量
    listenChange () {
      if (this.askTitle.length < 4) {
        this.askTip = "至少输入4个字";
        this.disabled = true;
      } else {
        this.askTip = "";
        this.disabled = false;
      }
    },
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.listenScroll);
  },
};
</script>
<style lang="scss" >
@import "../../assets/css/config";
.Topstory-container {
  display: flex;
  width: 1200px;
  padding: 0 16px;
  margin: 10px auto;
  height: 100%;
}
.Topstory-mainColumn {
  position: relative;
  width: 854px;
  height: 100%;
  .el-tabs__header {
    background: #ffffff;
    padding: 10px 20px;
    margin: 0;
    border-bottom: 1px solid #ebebeb;
  }
  .el-tabs__item {
    font-size: 16px;
  }
  .el-tabs__item.is-active {
    color: $mainColor;
  }
  .el-tabs__nav-wrap::after {
    background: transparent;
  }
  .el-tabs__active-bar {
    height: 0;
  }
}
.GlobalSideBar {
  margin-left: 10px;
  flex: 1;
}
.Loading {
  height: 50px;
  text-align: center;
  color: $mainColor;
}
.AskButton {
  color: #fff;
  background-color: #0084ff;
  width: 90px;
  padding: 8px 16px;
  font-size: 14px;
  margin-top: 10px;
  align-self: flex-end;
  &:disabled {
    opacity: 0.5;
  }
  position: absolute;
  top: 4px;
  right: 2.6%;
  border-radius: 999px;
  width: 70px;
}

.teacherInformation {
  //display: flex;
  margin-top: 15px;
  background-color: white;
  width: 1170px;
  // padding: 0 16px;
  margin: 10px auto;
  height: 100%;
  .teacher_contop {
    height: 240px;
    z-index: 0;
    background: #76a6c8 url(../../assets/images/innertopbg.jpg) no-repeat 50% 0;
  }
  .teacherpic_box {
    padding-bottom: 20px;
    display: flex;
    align-items: flex-end;
    margin-top: -80px;
    img {
      border-radius: 8px;
      border: 4px solid #fff;
      // border: 6px solid #fff;
      width: 160px;
      height: 160px;
      // border-radius: 100%;
      display: block;
      overflow: hidden;
      text-align: center;
      margin-left: 40px;
      margin-right: 25px;
      background: #fff;
    }
    .teacherinfo {
      p {
        &:nth-child(1) {
          font-size: 24px;
          height: 24px;
          line-height: 24px;
          color: #333;
        }
        &:nth-child(2) {
          font-size: 12px;
          margin-top: 40px;
          color: #999;
        }
      }
    }
  }
}
</style>

